module.exports = __webpack_public_path__ + "static/media/twitter.e7e417ad.svg";